export function stockVisibleFicha(producto, sucursalId) {
  const filas = Array.isArray(producto && producto.stock_por_sucursal) ? producto.stock_por_sucursal : [];
  if (!filas.length) {
    return { cantidad: null, stockMinimo: null, filas: [], sucursalId: null, nombre: null };
  }
  const elegida = sucursalId
    ? filas.find((fila) => fila.sucursal_id === sucursalId)
    : null;
  const principal = elegida || (filas.length === 1 ? filas[0] : null);
  return {
    cantidad: principal ? principal.cantidad : null,
    stockMinimo: principal && principal.stock_minimo != null ? principal.stock_minimo : null,
    filas,
    sucursalId: principal ? principal.sucursal_id : null,
    nombre: principal ? (principal.nombre || principal.sucursal_id) : null
  };
}
